
//Indeed Job API Utils
var indeedAttribution = '<span id="indeed_at"><a title="Job Search" href="https://ca.indeed.com" rel="nofollow" >jobs by <img alt=Indeed src="https://www.indeed.com/p/jobsearch.gif" style="border: 0; vertical-align: middle;"></a></span>';

//API documentation here: https://ads.indeed.com/jobroll/xmlfeed

//<script type="text/javascript" src="http://gdc.indeed.com/ads/apiresults.js"></script>

// Lookup job by key 51c3f052c6b86efc
//  http://api.indeed.com/ads/apigetjobs?publisher=2258527099239094&v=2&format=json&jobkeys=51c3f052c6b86efc

/*
==Basic Search Param
q: "String of terms"

==Advanced Query
q: all words "exact phrase" (at or least or one) title:(words in title) company:(company name) -none -of -these

anded:          all words
exact phrase:   "exact phrase"
any:            (red or green or blue),
none:           -none -of -these
in title:       title:(words in title)
company name:   company:(Apple Computer)

==example:
q: 'full time "administrative assisstant" (full or part) title:(assisstant) -internship -temporary'
*/


//NOTE TO SELF: start and end are array slice positions, so start 9, limit 9 returns listings 10 to 18

var jobFetcher = function(options){
    var _self = this;
    //defaults don't include location,query params, ip,start offset
    this.defaults = {
        radius: 50,
        fromage: 30,
        sort: "relevance",
		latlong: 1, //returns lat and long info
        limit: 9,
        start: 0
    }
    this.settings = $.extend({}, this.defaults, options);
    //console.log(_self.settings);
    return _self;
}

//use as promise
jobFetcher.prototype.fetch = function() {
    var _self = this;
    return new Promise(function(resolve, reject) {
        httpGetExternal( buildRoute(mantlroutes.portfolio_jobsearch) + formatParams(_self.settings)).then(
            function(value) {
                var response = JSON.parse(value);
                //console.log(response);
                resolve(response);
            })
        .catch(
            function(reason) {
                console.error('Error loading Indeed job results.', reason);
                reject(false);
            });
    });
}












// Functions
